import VerbalIdentityView from '@/views/VerbalIdentity/index.vue'
import PersonaView from '@/views/VerbalIdentity/submenu/Persona.vue'
import PraticeView from '@/views/VerbalIdentity/submenu/Pratice.vue'
import SummaryView from '@/views/VerbalIdentity/submenu/Summary.vue'
import ToneView from '@/views/VerbalIdentity/submenu/Tone.vue'
import VerbalIdentity from '@/views/VerbalIdentity/submenu/VerbalIdentity.vue'
import VozView from '@/views/VerbalIdentity/submenu/Voz.vue'
import ContentView from '@/views/VerbalIdentity/submenu/Content.vue'
import { component } from 'vue/types/umd'

export default {
  path: '/identidade-verbal',
  component: VerbalIdentityView,
  children: [
    {
      path: '',
      name: 'identidade-verbal',
      component: VerbalIdentity
    },
    {
      path: 'persona',
      name: 'identidade-verbal.persona',
      component: PersonaView      
    },
    {
      path: 'voz',
      name: 'identidade-verbal.voz',
      component: VozView 
    },
    {
      path: 'tom',
      name: 'identidade-verbal.tom',
      component: ToneView      
    },
    {
      path: 'na-pratica',
      name: 'identidade-verbal.na-pratica',
      component: PraticeView
    },
    {
      path: 'conteudo',
      name: 'identidade-verbal.conteudo',
      component: ContentView
      
    },
    {
      path: 'resumindo',
      name: 'identidade-verbal.resumindo',
      component: SummaryView
      
    }
  ]
}
